import { AnyAction } from 'redux';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { STATE } from 'app/constants';
import { ErrorNotification, SuccessNotification } from 'app/infrastructure/notifications/user-messages';
import { isForbiddenStatus, blockAccess } from 'app/area/shared/actions-utils';
import { experienceTransferTranslation } from '../constants';
import { defaultMaxResults } from './constants';
import {
  ClearList, RequestList, ReceiveList, FailList,
  RequestDeleteExperienceTransfer, ReceiveDeleteExperienceTransfer, FailDeleteExperienceTransfer
} from './action-types';
import { api } from './api';
import { mapList } from './map-list';
import { ExperienceTransferSearchModel } from './types-store';
import { replaceTemplateString } from 'app/infrastructure/platform';

export const actionCreators = {

  loadExperienceTransferList: (
    model: ExperienceTransferSearchModel,
    startIndex: number = 0,
    maxResults: number = defaultMaxResults
  ): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch, getState) => {

      const requestId = Date.now();
      dispatch(new RequestList(requestId, model, startIndex === 0));

      try {

        const listResponse = await api.loadExperienceTransferList(model, startIndex, maxResults);
        dispatch(new ReceiveList(requestId, mapList(listResponse.results), listResponse.totalNumberOfResults));

      } catch (err) {
        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));

        if (isForbiddenStatus(err)) {
          blockAccess({
            dispatch,
            getState,
            area: STATE.experienceTransfer,
            translationId: experienceTransferTranslation.no_access_to_experience_transfer
          });
        }

        dispatch(new FailList(requestId));
      }
    },

  deleteExperienceTransfer: (id: number, text: string, successMessage: string): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      dispatch(new RequestDeleteExperienceTransfer(id));

      try {

        await api.deleteExperienceTransfer(id);
        dispatch(new ReceiveDeleteExperienceTransfer(id));
        dispatch(new SuccessNotification(replaceTemplateString(successMessage, text)));

      } catch (err) {

        if (err && (err.userMessages || err.message)) {
          dispatch(new ErrorNotification(err.userMessages || err.message));
        }
        dispatch(new FailDeleteExperienceTransfer(id));
      }
    },

  clearList: (): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {
      const requestId = Date.now();
      dispatch(new ClearList(requestId));
    },

  displayError: (errorMessage: string): ActionDispatching<any, any> =>
    (dispatch, getState) => {
      dispatch(new ErrorNotification(errorMessage));
    }
};
